/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./assetsInfoR.vue?vue&type=template&id=7b47cd84"
import script from "./assetsInfoR.vue?vue&type=script&lang=js"
export * from "./assetsInfoR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports